import OptionConst from "@/const/Option";
import { PxService } from "@/service/PxService";
import { CheckListReq, CheckListRes } from "@/types/Px";
import { computed, ref, Ref } from "vue"
import { useForm } from '@/composable/form/form';
import { AxiosError } from "axios";
import { FormUtil } from "@/utils/FormUtil";
/*
 * 勤務承認の確定状況をを取得
 */
export function useList() {
  let checking = ref(0);
  let isListError = ref(false);
  let checkListInfo:Ref<CheckListRes> = ref({
    dakoku: [],
    summary: [],
    start: '',
    end: ''
  });
  const { removeAllError } = useForm()

  // 読み込み中か判断する
  const isListChecking = computed(() => {
    return !(checking.value === 0 || isListError.value);
  });

  // 一覧取得
  const getList = async (form: Ref<CheckListReq>) => {
    checking.value++;
    removeAllError(form.value)
    isListError.value = false

    // API
    const srv = new PxService();
    await srv.getKinmuStatusForPx(form.value).then(v => {
      if (v) {
        checkListInfo.value = v;
      }
    }).catch(e => {
      const err = e as AxiosError<any>
      FormUtil.setLaravelError(form.value, err)
      isListError.value = true
    });
    checking.value--;
  };

  const syouninStatus = (statusId: number) => {
    const status = OptionConst.DAKOKU_SYOUNIN_STATUS_OPTION.find(item => item.val === statusId)
    if (status) {
      return status.label
    } else {
      return '-'
    }
  }

  return {
    isListChecking,
    isListError,
    getList,
    syouninStatus,
    checkListInfo,
  };
}
